<script lang="ts" setup>
import VueSelect from 'vue-select'

// Define the type for the context prop
interface SelectContext {
  id?: string
  value: any
  attrs: {
    'select-options': Array<{ value: any; label: string }>
    'handle-focus-fn': (focused: boolean) => void
    required?: boolean
  }
  node: {
    input: (value: any) => void
  }
}

const props = defineProps<{
  context: SelectContext
}>()

const initialValue = props.context.attrs['select-options'].find((option) => option.value === props.context.value)

const selected = ref(initialValue)

watch(
  () => props.context.value,
  (value) => {
    if (!value) return
    if (value === selected.value?.value) return
    selected.value = props.context.attrs['select-options'].find((option) => option.value === value)
  },
)
</script>

<template>
  <VueSelect
    v-model="selected"
    :input-id="context?.id"
    :options="context?.attrs['select-options'] ?? []"
    :clearable="false"
    @option:selected="(option) => context?.node.input(option.value ?? option.label)"
    @open="context?.attrs['handle-focus-fn'](true)"
    @close="() => context?.attrs['handle-focus-fn'](false)"
  >
    <template v-if="context?.attrs.required" #search="{ attributes, events }">
      <input class="vs__search" aria-required="true" v-bind="attributes as any" v-on="events" />
    </template>
    <template #open-indicator="{ toggleAttributes }">
      <span v-bind="toggleAttributes as {}"><Icon name="dropdown" /></span>
    </template>
  </VueSelect>
</template>

<style lang="scss" scoped></style>
